import React from "react";
import { Paper, Typography, Box, Divider, Stack } from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import UpdateIcon from "@mui/icons-material/Update";
import EditIcon from "@mui/icons-material/Edit";
import InfoIcon from "@mui/icons-material/Info";
import CodeIcon from "@mui/icons-material/Code";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
// For interface/API related icons, you could use:
import ApiIcon from "@mui/icons-material/Api";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
  timelineItemClasses,
} from "@mui/lab";
import SourceIcon from "./sourceIcon";
import ChangeStatus from "./changeStatus";
import UpdateData from "./updateData";
import Function_executed from "./function_executed";
import Interface from "./interface";
import PostAddIcon from "@mui/icons-material/PostAdd"; // Document with plus

const LogsDisplay = ({ logs }) => {
  const formatLogsByDate = (logs) => {
    const groupedLogs = {};

    logs?.forEach((log) => {
      const date = new Date(log.timestamp).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
      if (!groupedLogs[date]) groupedLogs[date] = [];
      groupedLogs[date].push(log);
    });
    return groupedLogs;
  };

  const groupedLogs = formatLogsByDate(logs);

  const getIcon = (action, lastItem) => {
    const iconMap = {
      changeStatus: <UpdateIcon color="primary" fontSize="small" />,
      updateData: <EditIcon sx={{ color: "#9c27b0" }} fontSize="small" />,
      updated: <EditIcon color="action" fontSize="small" />,
      interface: <ApiIcon fontSize="small" />,
      added: <PostAddIcon sx={{ color: "#9c27b0" }} fontSize="small" />,
      function_executed: <CodeIcon fontSize="small" color="primary" />,
    };

    return (
      <TimelineSeparator
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "100%",
        }}
      >
        <TimelineDot
          sx={{
            boxShadow: "none",
            bgcolor: "background.paper",
            borderColor: "grey.300",
            my: 0,
            p: 1,
            zIndex: 1,
          }}
          variant="outlined"
        >
          {iconMap[action] || <AutoAwesomeIcon sx={{ color: "#64b5f6" }} fontSize="small" />}
        </TimelineDot>
        {lastItem && (
          <TimelineConnector
            sx={{
              bgcolor: "grey.300",
              width: "2px",
              height: "100%", // Fill the full height
              mt: "-1px", // Negative margin to connect to top dot
              mb: "-50px", // Negative margin to connect to bottom dot
              position: "relative",
              zIndex: 0,
            }}
          />
        )}
      </TimelineSeparator>
    );
  };

  const buildTemplate = (log) => {
    // const time = new Date(log.timestamp).toLocaleTimeString("en-US", {
    //   hour: "2-digit",
    //   minute: "2-digit",
    // });
    console.log(
      "buildTemplate",
      log.action,
      log.details.automationDetails?.name,
      log.details.automationDetails?.rule?.name
    );

    switch (log.action) {
      case "changeStatus": //priority status logs
        return <ChangeStatus log={log} />;
      case "updateData": //priority changes logs
        return <UpdateData log={log} />;
      case "updated":
      case "added":
      case "function_executed": //zoho
        return <Function_executed log={log} />;
      case "interface": //priority status logs
        return <Interface log={log} />;
      default:
        return <Function_executed log={log} />;
    }
  };

  return (
    <Box sx={{ p: 2, direction: 'rtl'}}>
      {Object.keys(groupedLogs).map((date) => (
        <Paper key={date} elevation={3} sx={{ p: 2, mb: 3 }}>
          {/* Date Header */}
          <Box
            display="flex"
            alignItems="center"
            mb={1}
            flexDirection="row-reverse"
          >
            <Typography
              variant="h6"
              sx={{
                backgroundColor: "#f1f5ff",
                color: "#333",
                padding: "4px 8px",
                borderRadius: "8px",
                fontWeight: "bold",
              }}
            >
              {date}
            </Typography>
          </Box>
          <Divider sx={{ mb: 2 }} />

          {/* Log Entries */}
          <Stack spacing={2}>
            <Timeline
              sx={{
                "& .MuiTimelineItem-root": {
                  flexDirection: "row-reverse", // Reverses the order of elements
                },
                [`& .${timelineItemClasses.root}:before`]: {
                  display: "none", // Removes the default spacing
                },
                '& .MuiTimelineOppositeContent-root': {
                textAlign: 'right'  // Add this
              }
              }}
            >
              {groupedLogs[date].map((log, index) => {
                return (
                  <Box
                    key={index}
                    display="flex"
                    flexDirection="row-reverse"
                    // flexDirection="row" 
                    // alignItems="flex-start"
                    sx={{ mb: 3, width: '100%' }}
                  >
                    <TimelineItem key={index}>
                      <TimelineOppositeContent sx={{ flex: "0 0 40px", textAlign: 'right'  }}>
                        <Typography variant="body2" color="text.secondary">
                          {new Date(log.timestamp).toLocaleTimeString("he-IL", {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </Typography>
                      </TimelineOppositeContent>
                      <Box sx={{ mr: 2 }}>
                        {getIcon(
                          log.action,
                          groupedLogs[date].length - 1 != index
                        )}
                      </Box>

                      {/* {buildTemplate(log)} */}
                      <Box dir="rtl" sx={{ 
                      width: '100%',  // Add this
                      textAlign: 'right'  // Add this
                    }}>{buildTemplate(log)}</Box>
                    </TimelineItem>
                    <br></br>
                    {"  "}
                  </Box>
                );
              })}
            </Timeline>
          </Stack>
        </Paper>
      ))}
    </Box>
  );
};

export default LogsDisplay;